import { Box, Text } from '@chakra-ui/react';
import React from 'react';
import { getDivider,  } from '../utils';
import { setUcfirst } from '../../../handlers/helpers';

const PreviewEducation = ({ items }) => {
  return (
      <Box className="contentBox">
        {Object.values(items.map((item) => {
              const courseWork = typeof item.courses !== 'undefined' && item.courses !== '' ? 'Completed coursework in ' + item.courses + '.': '';
              let address = '';
              if(item.location === 'inperson') {
                const city = item.city === undefined ? '' : item.city;
                const state = item.state === undefined ? '' : item.state;
                address = city + getDivider(city, state, ', ') + state;
              } else {
                address = 'Remote';
              }
              return (
                <Text className='subSections' >
                  {/*Text is necessary above to make _last work*/}
                  <Box className='subSectionsInterior'>
                    <Box className='subSection'>
                      <Text className='name'>{item.institution}</Text>
                    </Box>
                    <Box className='address'>
                      <Box className='alignRight'>{setUcfirst(address)}</Box>
                    </Box>
                  </Box>
                  <Box>
                    <Box className='educationItemWrap'>
                      <Box className='educationItem'><Text  fontWeight='bold'>{item.degree}</Text>
                        <Text className='educationItemText'>{getDivider(item.degree, item.major)}</Text><Text>{item.major}</Text>
                      </Box>
                      <Box className='alignRight dates'>{item.end_month} {item.end_year}</Box>
                    </Box>
                  </Box>
                  <Box>
                    <Text>{courseWork}</Text>
                  </Box>
                </Text>
              )
                ;
            },
          ),
        )
        }
      </Box>
  );
};
export default PreviewEducation;
